var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseCircleSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.875C4 5.29258 4 5.00136 4.09515 4.77165C4.22201 4.46536 4.46536 4.22201 4.77165 4.09515C5.00136 4 5.29258 4 5.875 4C6.45743 4 6.74863 4 6.97838 4.09515C7.28463 4.22201 7.528 4.46536 7.65488 4.77165C7.75 5.00136 7.75 5.29258 7.75 5.875V12.125C7.75 12.7074 7.75 12.9986 7.65488 13.2284C7.528 13.5346 7.28463 13.778 6.97838 13.9049C6.74863 14 6.45743 14 5.875 14C5.29258 14 5.00136 14 4.77165 13.9049C4.46536 13.778 4.22201 13.5346 4.09515 13.2284C4 12.9986 4 12.7074 4 12.125V5.875Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5.875C10.25 5.29258 10.25 5.00136 10.3451 4.77165C10.472 4.46536 10.7154 4.22201 11.0216 4.09515C11.2514 4 11.5426 4 12.125 4C12.7074 4 12.9986 4 13.2284 4.09515C13.5346 4.22201 13.778 4.46536 13.9049 4.77165C14 5.00136 14 5.29258 14 5.875V12.125C14 12.7074 14 12.9986 13.9049 13.2284C13.778 13.5346 13.5346 13.778 13.2284 13.9049C12.9986 14 12.7074 14 12.125 14C11.5426 14 11.2514 14 11.0216 13.9049C10.7154 13.778 10.472 13.5346 10.3451 13.2284C10.25 12.9986 10.25 12.7074 10.25 12.125V5.875Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircleSvgrepoCom1);
export default __webpack_public_path__ + "static/media/pause-circle-svgrepo-com 1.c7bf90c535c48a0520d59358de5e5512.svg";
export { ForwardRef as ReactComponent };